import React from "react";
import { Fade } from "react-reveal";
import styled from "styled-components";
import LText from "./LogoText";

const AboutContent = () => {
  return (
    <Container>
      <LText text={"Nossa Fisolofia é Você!"} />
      <span>
        <Fade left>
          <img
            src="https://a2723d7d63.cbaul-cdnwnd.com/c9a4f07398f99ecd18a2ed68de83a17a/200000004-ae819ae81c/700/images%20-%202021-06-01T220246.901.jpeg?ph=a2723d7d63"
            alt=""
          />
        </Fade>

        <Fade left>
          <h2>
            Mendes & Herrero é uma empresa pioneira no ramo de internação, com
            unidades em todo estado de São Paulo. Nossos profissionais são
            altamente qualificados, treinados e bem preparados para resgatar e
            salvar vidas, reintegrando pacientes ao convívio social e familiar.
            A satisfação dos nossos clientes é a nossa maior prioridade.
          </h2>
        </Fade>
      </span>
    </Container>
  );
};

export default AboutContent;

const Container = styled.div`
  width: 100%;
  height: 100%;

  span {
    padding-top: 30px;
    width: 90%;
    margin: auto;
    display: flex;
    justify-content: center;
    div {
      margin: auto;
    }
    img {
      width: 400px;
      height: 70%;
      border-radius: 5%;
      margin-right: 45px;
    }
    h2 {
      color: #fff;
      font-family: "Jost", sans-serif;
      font-size: 20px;
      margin-top: 50px;
      width: 30%;
    }
  }
  @media (max-width: 850px) {
    span {
      flex-wrap: wrap;
      img {
        width: 85%;
      }
      h2 {
        width: 95%;
      }
    }
  }
`;
